import React from "react";
import pictureOne from "./assets/picOne.png";
import { Link } from "react-router-dom";

const StandardsServices = () => {
  return (
    <div className="about-us">

      {/* === Header Section === */}
      <section className="about-header">
        <div className="overlay">
          <h1 className="page-title">MBS-SIC Membership Scheme</h1>
          <p className="subtitle">
            Access standards and related information through the Malawi Bureau of Standards Standards Information Centre.
          </p>
        </div>
      </section>

      {/* === MBS-SIC Membership Scheme Section === */}
      <section className="what-section">
        <p>
          The MBS operates a Library Membership Scheme (MBS Standards Information Centre Scheme – MBS-SIC Scheme), 
          which enables stakeholders to access standards and standards related information available in the MBS Standards Information Centre. 
          The MBS-SIC Scheme provides Malawi standards, International Standards, regional standards, foreign national standards, industrial books, journals, magazines, brochures, catalogues of National and International Standards, among others. 
          The following are other benefits of the scheme:
        </p>
        <ul>
          <li>Access to the information resources highlighted above for free.</li>
          <li>20% reduction in the purchase of Malawi Standards.</li>
          <li>Receipt of periodicals and other relevant documents and information from the MBS. These include: Catalogue of Malawi Standards, MBS Annual Report, Information leaflets, etc.</li>
        </ul>
        <p>
          The MBS receives various information from the International Organization for Standardization (ISO), International Electrotechnical Commission (IEC), Codex Alimentarius Commission (CAC), Food and Agriculture Organization (FAO), World Trade Organization (WTO), National Standards from a number of countries worldwide, among others.
        </p>
        <p>Current Annual subscription rates for the scheme are as follows:</p>
        <table className="membership-table">
          <thead>
            <tr>
              <th>Category of membership</th>
              <th>Annual subscription</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Institutional membership</td>
              <td>MWK5,000</td>
            </tr>
            <tr>
              <td>Individual membership</td>
              <td>MWK2,000</td>
            </tr>
          </tbody>
        </table>

        {/* === Membership Application Link === */}
        <p style={{ marginTop: "20px" }}>
          To join the membership scheme, click this link:{" "}
          <Link to="/applyMBS-SIC" style={{ color: "red", textDecoration: "none", fontWeight: "" }}>
            Apply for MBS-SIC Membership
          </Link>.
        </p>
      </section>

      {/* === Inline CSS === */}
      <style>{`
        .about-us { font-family: Arial, sans-serif; color: #333; }

        .about-header {
          background-image: url(${pictureOne});
          background-size: cover;
          background-position: center;
          height: 45vh;
          display: flex;
          align-items: center;
          justify-content: center;
          position: relative;
        }

        .overlay {
          background: rgba(0,0,0,0.55);
          padding: 40px;
          text-align: center;
          color: white;
          width: 90%;
          max-width: 1200px;
          box-sizing: border-box;
          border-radius: 8px;
        }

        .page-title { font-size: 2.5rem; font-weight: bold; }
        .subtitle { margin-top: 10px; font-size: 1rem; }

        .what-section { padding: 50px 80px; font-size: 1rem; line-height: 1.6; }
        .what-section ul { margin-left: 20px; margin-bottom: 20px; }
        .what-section li { margin-bottom: 10px; }

        .membership-table { width: 50%; border-collapse: collapse; margin-top: 15px; }
        .membership-table th, .membership-table td { border: 1px solid #ddd; padding: 8px 12px; text-align: left; }
        .membership-table th { background-color: #f4f4f4; font-weight: bold; }
      `}</style>

    </div>
  );
};

export default StandardsServices;
